import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-163" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto max-w-5xl" data-id="element-164" data-mp="3ksgwy4rr2bbc">
        <h2 className="text-center font-display text-[1.75rem] font-black uppercase leading-tight tracking-tight text-brand sm:text-[2.4rem]" data-id="element-165" data-mp="3fyvxs9ef7bak">
          What Coaches Are Saying
        </h2>
        <p className="mt-3 text-center text-sm font-medium text-ink/70" data-id="element-166" data-mp="36zilza2tqamo">
          <span aria-hidden="true" data-id="element-167" data-mp="36wmqdseg7y1e">⭐⭐⭐⭐⭐</span> 4.9/5 · Trusted by 2,500+
          Coaches
        </p>

        <div className="mx-auto mt-10 grid max-w-4xl gap-5 sm:grid-cols-2" data-id="element-168" data-mp="2x0tf0ccgual7">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl border border-brand/10 bg-cream p-6" data-id="element-169" data-mp="2s28dm9lh9kv6">
              <div className="text-sm text-lime-dark" aria-label="5 out of 5 stars" data-id="element-170" data-mp="v7c9pfbt5ltm">
                <span aria-hidden="true" data-id="element-171" data-mp="h67wpwq6ta6o">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-ink/85" data-id="element-172" data-mp="h8azlhcfuxst">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-173" data-mp="7928cw8yjxa5">
                <p className="font-display text-xs font-black uppercase tracking-wide text-brand" data-id="element-174" data-mp="7a4yv32dbxpj">
                  {item.name}
                </p>
                <p className="text-xs text-ink/50" data-id="element-175" data-mp="zxh9qfz62h30">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-ink/40" data-id="element-176" data-mp="14xlu4h373vyi">
          Illustrative placeholder testimonials.
        </p>
      </div>
    </section>;
}